(function () {

  // ─── WAITLIST COUNTER ANIMATION ──────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    var counterEl = document.querySelector('.waitlist-counter');
    var numEl     = document.querySelector('.waitlist-counter__num');
    if (!counterEl || !numEl) return;

    var SCRIPT_URL  = 'https://script.google.com/macros/s/AKfycby3oBdx4T-CC1udNpjkifY6SajF5YKl8iJvbjLZiiWKpXvTbjx-L7e5i-cPpYHQ8rtZ/exec';
    var CACHE_KEY   = 'wl_count';
    var fallback    = parseInt(numEl.dataset.target, 10) || 0;
    var cached      = parseInt(localStorage.getItem(CACHE_KEY), 10) || 0;

    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function show(target, animate) {
      if (document.querySelector('.waitlist-success')) return;
      if (target <= 0) { numEl.textContent = '0'; return; }
      var duration = Math.min(1500, Math.max(700, target * 5));
      var start = null;
      numEl.textContent = '0';
      function tick(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        numEl.textContent = Math.round(easeOut(progress) * target).toLocaleString();
        if (progress < 1) requestAnimationFrame(tick);
        else numEl.textContent = target.toLocaleString();
      }
      requestAnimationFrame(tick);
    }

    fetch(SCRIPT_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var live = parseInt(data.count, 10) || fallback;
        if (live > 0) localStorage.setItem(CACHE_KEY, live);
        show(live, true);
      })
      .catch(function () { show(cached || fallback, true); });
  });
  // ─────────────────────────────────────────────────────────────────────────────

  // ─── WAITLIST SUCCESS STATE ───────────────────────────────────────────────────
  function showWaitlistSuccess() {
    var form = document.getElementById('waitlist-form');
    if (!form) return;
    var errEl = form.querySelector('.waitlist-error');
    if (errEl && errEl.style.display !== 'none') return;
    var row = form.querySelector('.waitlist-form__row');
    if (!row) return;
    var msg = form.getAttribute('data-success-msg') || "You're on the list! We'll be in touch soon.";
    var success = document.createElement('p');
    success.className = 'waitlist-success';
    success.setAttribute('role', 'status');
    success.setAttribute('aria-live', 'polite');
    success.setAttribute('tabindex', '-1');
    success.textContent = msg;
    row.replaceWith(success);
    var counterEl = document.querySelector('.waitlist-counter');
    if (counterEl) counterEl.style.display = 'none';
    if (!document.getElementById('interest-prompt')) {
      var prompt = document.createElement('div');
      prompt.className = 'interest-prompt';
      prompt.id = 'interest-prompt';
      prompt.innerHTML = '<button type="button" class="interest-prompt__btn" id="interest-open-btn">Help shape SpoonWrap →</button><p class="interest-prompt__hint">2 minutes · completely optional</p>';
      success.insertAdjacentElement('afterend', prompt);
    }
    success.focus();
  }
  // ─────────────────────────────────────────────────────────────────────────────


  // ─── EMAIL VALIDATION ────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    // Post-redirect success: Shopify only redirects to return_to on a successful submission,
    // so ?wl_ok=1 in the URL means the email was actually recorded.
    if (new URLSearchParams(window.location.search).get('wl_ok') === '1') {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname);
      }
      var wlEmail = sessionStorage.getItem('wl_email') || '';
      if (wlEmail) {
        fetch('https://script.google.com/macros/s/AKfycby3oBdx4T-CC1udNpjkifY6SajF5YKl8iJvbjLZiiWKpXvTbjx-L7e5i-cPpYHQ8rtZ/exec', {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ action: 'waitlist', email: wlEmail })
        }).catch(function () {});
      }
      showWaitlistSuccess();
    }

    var form = document.getElementById('waitlist-form');
    if (!form) return;

    var input = form.querySelector('input[type="email"]');
    var emailError = document.getElementById('waitlist-error');

    function showEmailError(msg) {
      if (!emailError) {
        emailError = document.createElement('p');
        emailError.className = 'waitlist-error';
        emailError.setAttribute('role', 'alert');
        emailError.setAttribute('id', 'waitlist-error');
        var row = form.querySelector('.waitlist-form__row');
        if (row) row.insertAdjacentElement('afterend', emailError);
        else form.appendChild(emailError);
      }
      emailError.textContent = msg;
      emailError.style.display = '';
    }

    function hideEmailError() {
      if (emailError) emailError.style.display = 'none';
    }

    function isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val.trim());
    }

    input.addEventListener('input', function () {
      if (isValidEmail(input.value)) hideEmailError();
    });

    form.addEventListener('submit', function (e) {
      var val = input.value.trim();
      if (!val) {
        e.preventDefault();
        input.focus();
        showEmailError('Please enter your email address.');
      } else if (!isValidEmail(val)) {
        e.preventDefault();
        input.focus();
        showEmailError('Please enter a valid email address.');
      } else {
        hideEmailError();
        sessionStorage.setItem('wl_email', val);
      }
    });
  });
  // ─────────────────────────────────────────────────────────────────────────────

  // ─── INTEREST FORM ───────────────────────────────────────────────────────────
  // The survey uses a plain <div> (not a <form>) so Shopify's storefront scripts
  // cannot hook into it and trigger captcha. Submission is handled entirely by
  // a click listener on the button; data is sent via fetch in the background.
  document.addEventListener('DOMContentLoaded', function () {
    var section   = document.getElementById('interest-section');
    var openBtn   = document.getElementById('interest-open-btn');
    var skipBtn   = document.getElementById('interest-skip-btn');
    var submitBtn = document.getElementById('interest-submit-btn');
    var formDiv   = document.getElementById('interest-form');
    var thanks    = document.getElementById('interest-thanks');
    if (!section) return;

    function openSection() {
      section.removeAttribute('inert');
      section.removeAttribute('aria-hidden');
      section.classList.add('is-open');
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () {
        var first = section.querySelector('select, input, button, textarea');
        if (first) first.focus();
      }, 520);
    }

    function closeSection() {
      section.classList.remove('is-open');
      section.setAttribute('inert', '');
      section.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.focus();
    }

    if (openBtn) openBtn.addEventListener('click', openSection);
    if (skipBtn) skipBtn.addEventListener('click', closeSection);

    // ── Size pickers ──
    document.querySelectorAll('.size-picker').forEach(function (picker) {
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('.size-btn');
        if (!btn) return;
        picker.querySelectorAll('.size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      });
    });

    // ── Color picker Enter key ──
    document.querySelectorAll('.color-picker input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); cb.click(); }
      });
    });

    // ── Country "Other" ──
    var countrySelect = document.getElementById('interest-country');
    var countryOther  = document.getElementById('interest-country-other');
    if (countrySelect && countryOther) {
      countrySelect.addEventListener('change', function () {
        countryOther.style.display = countrySelect.value === 'Other' ? 'block' : 'none';
      });
    }

    // ── Height unit toggle ──
    var heightToggle   = document.getElementById('height-unit-toggle');
    var heightImperial = document.getElementById('height-imperial');
    var heightMetric   = document.getElementById('height-metric');
    var usingMetric    = false;
    if (heightToggle) {
      heightToggle.addEventListener('click', function () {
        usingMetric = !usingMetric;
        if (usingMetric) {
          heightImperial.style.display = 'none';
          heightMetric.style.display   = '';
          heightToggle.textContent     = 'Switch to ft / in';
          var ft = parseFloat(document.getElementById('height-ft').value) || 0;
          var ins = parseFloat(document.getElementById('height-in').value) || 0;
          if (ft || ins) document.getElementById('height-cm').value = Math.round((ft * 12 + ins) * 2.54);
        } else {
          heightImperial.style.display = '';
          heightMetric.style.display   = 'none';
          heightToggle.textContent     = 'Switch to cm';
          var cm = parseFloat(document.getElementById('height-cm').value) || 0;
          if (cm) {
            var totalIn = cm / 2.54;
            document.getElementById('height-ft').value = Math.floor(totalIn / 12);
            document.getElementById('height-in').value = Math.round(totalIn % 12);
          }
        }
      });
    }

    // ── Submit button click ──
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        // Compile survey body
        var country = countrySelect ? countrySelect.value : '';
        if (country === 'Other' && countryOther) country = countryOther.value || 'Other';

        var shirtBtn = document.querySelector('#shirt-size-picker .size-btn.is-selected');
        var pantsBtn = document.querySelector('#pants-size-picker .size-btn.is-selected');

        var heightStr = '';
        if (usingMetric) {
          var cm = document.getElementById('height-cm').value;
          if (cm) heightStr = cm + ' cm';
        } else {
          var ft  = document.getElementById('height-ft').value;
          var ins = document.getElementById('height-in').value;
          if (ft || ins) heightStr = (ft || '0') + "'" + (ins || '0') + '"';
        }

        var colors = [];
        document.querySelectorAll('.color-picker input[type="checkbox"]:checked').forEach(function (cb) {
          colors.push(cb.value);
        });

        var suggestions = (document.getElementById('interest-suggestions') || {}).value || '';

        // Fade out the form, swap to thank-you content, then animate the section closed
        if (formDiv) {
          formDiv.style.transition = 'opacity 0.35s ease';
          formDiv.style.opacity    = '0';
        }

        setTimeout(function () {
          if (formDiv) formDiv.style.display = 'none';

          // Hide the header, centre and show the thank-you block
          var header = section.querySelector('.interest-section__header');
          if (header) header.style.display = 'none';
          section.classList.add('is-thanked');

          if (thanks) {
            thanks.style.opacity    = '0';
            thanks.style.display    = 'block';
            thanks.style.transition = 'opacity 0.35s ease';
            void thanks.offsetWidth;
            thanks.style.opacity    = '1';
          }

          // After the user has a moment to read it, animate the section closed
          setTimeout(function () {
            section.classList.remove('is-open');
            section.setAttribute('inert', '');
            section.setAttribute('aria-hidden', 'true');
          }, 2000);
        }, 380);

        fetch('https://script.google.com/macros/s/AKfycby3oBdx4T-CC1udNpjkifY6SajF5YKl8iJvbjLZiiWKpXvTbjx-L7e5i-cPpYHQ8rtZ/exec', {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({
            email:       sessionStorage.getItem('wl_email') || '',
            country:     country || 'Not specified',
            shirt:       shirtBtn ? shirtBtn.dataset.value : 'Not specified',
            pants:       pantsBtn ? pantsBtn.dataset.value : 'Not specified',
            height:      heightStr || 'Not specified',
            colors:      colors.length ? colors.join(', ') : 'None selected',
            suggestions: suggestions || ''
          })
        }).catch(function () {});
      });
    }
  });
  // ─────────────────────────────────────────────────────────────────────────────

  // ─── CUSTOM SPOON ────────────────────────────────────────────────────────────
  var SPOON_PATH = 'M2353 4440 c-584 -39 -1251 -213 -1727 -452 -157 -79 -257 -150 -359 -258 -302 -318 -345 -587 -140 -892 71 -106 219 -256 315 -320 162 -108 402 -217 693 -314 817 -272 1667 -326 2205 -139 253 89 459 219 755 480 291 256 371 314 490 355 105 36 170 39 599 30 226 -5 632 -14 901 -20 698 -15 1348 -28 1885 -40 503 -11 1115 -24 1880 -40 267 -6 679 -15 915 -20 1554 -34 1596 -34 1673 -17 155 35 265 118 325 244 29 62 32 77 32 163 0 86 -3 101 -32 163 -60 126 -170 209 -325 244 -77 17 -119 17 -1673 -17 -236 -5 -648 -14 -915 -20 -765 -16 -1377 -29 -1880 -40 -537 -12 -1187 -25 -1885 -40 -269 -6 -675 -15 -901 -20 -429 -9 -494 -6 -599 30 -119 41 -199 99 -490 355 -296 261 -502 391 -755 480 -253 88 -633 128 -987 105z';
  var SPOON_SVG        = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 1280 640" width="72" height="36" fill="#1d3557"><g transform="translate(0,640) scale(0.1,-0.1)"><path d="' + SPOON_PATH + '"/></g></svg>';
  var GOLDEN_SPOON_SVG = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 1280 640" width="88" height="44" fill="#FFD700"><g transform="translate(0,640) scale(0.1,-0.1)"><path d="' + SPOON_PATH + '"/></g></svg>';
  // ─────────────────────────────────────────────────────────────────────────────

  document.addEventListener('selectstart', function (e) {
    if (!e.target.closest('p, h1, h2, h3, h4, h5, h6, li, td, th, label, input, textarea, a, span, [contenteditable]')) {
      e.preventDefault();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('a, button, input')) return;

    var spoon = document.createElement('div');
    spoon.innerHTML = SPOON_SVG;
    var styles = [
      'position:fixed',
      'left:' + e.clientX + 'px',
      'top:' + e.clientY + 'px',
      'pointer-events:none',
      'user-select:none',
      'z-index:99999',
      'transform-origin:center',
      'will-change:transform',
      'line-height:0',
    ];
    spoon.style.cssText = styles.join(';');
    document.body.appendChild(spoon);

    var angleDeg = Math.random() * 60 - 30;
    var angleRad = angleDeg * (Math.PI / 180);
    var speed = 7 + Math.random() * 6;
    var vx = Math.sin(angleRad) * speed;
    var vy = -Math.cos(angleRad) * speed;
    var x = e.clientX;
    var y = e.clientY;
    var rot = Math.random() * 360;
    var rotSpeed = (Math.random() - 0.5) * 14;
    var gravity = 0.3;
    var lastTime = null;

    function tick(ts) {
      if (lastTime === null) { lastTime = ts; requestAnimationFrame(tick); return; }
      var dt = Math.min((ts - lastTime) / (1000 / 60), 4);
      lastTime = ts;

      vy += gravity * dt;
      x  += vx * dt;
      y  += vy * dt;
      rot += rotSpeed * dt;

      spoon.style.left      = x + 'px';
      spoon.style.top       = y + 'px';
      spoon.style.transform = 'rotate(' + rot + 'deg)';

      if (x < -80 || x > window.innerWidth + 80 || y > window.innerHeight + 80) {
        spoon.remove();
      } else {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  });

  // ─── GOFUNDME BUBBLE ─────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem('gfm_bubble')) return;

    setTimeout(function () {
      var gfmLink = document.querySelector('.waitlist-social-link--gfm');
      if (!gfmLink) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'gfm-bubble-wrap';
      gfmLink.parentNode.insertBefore(wrapper, gfmLink);
      wrapper.appendChild(gfmLink);

      var bubble = document.createElement('div');
      bubble.className = 'gfm-bubble';
      bubble.innerHTML = '<button class="gfm-bubble__close" aria-label="Close">✕</button><p class="gfm-bubble__text">Want to see this sooner? Donate today!</p>';
      wrapper.appendChild(bubble);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () { bubble.classList.add('gfm-bubble--visible'); });
      });

      bubble.querySelector('.gfm-bubble__close').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        sessionStorage.setItem('gfm_bubble', '1');
        bubble.classList.remove('gfm-bubble--visible');
        setTimeout(function () { bubble.remove(); }, 250);
      });
    }, 3000);
  });
  // ─────────────────────────────────────────────────────────────────────────────

})();
